import React, { useEffect, useState } from 'react';

import Header from '../../hoc/Layout/Header';
import NoAccessIcon from '../../assets/noAccessPage.svg';
import AppLoader from '../modules/FullPageLoader/AppLoader';

const NoAccessPage = () => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 2000);
  }, []);
  return (
    <div>
      <Header />
      <div style={{ width: '100vw', height: '50vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        {loading && <AppLoader />}
        <div style={{ height: '350px', display: 'flex', flexDirection: 'column' }}>
          <img style={{ width: '100%' }} src={NoAccessIcon} alt="no access page" />
          <div style={{ fontWeight: 800, fontSize: '36px' }}>You have no access to this page</div>
        </div>
      </div>
    </div>
  );
};

export default NoAccessPage;
